import React, { useEffect, useRef, useState } from "react";

/**
 * Dropdown menu (topbar "+ New", user menu, table kebab menus).
 * items: array of
 *   { type: "separator" } |
 *   { type: "label", label } |
 *   { label, icon?, hint?, danger?, disabled?, onSelect }
 * `trigger` is a render function: (open, toggle) => node.
 */
function Menu({ trigger, items, align = "right" }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const onDocMouseDown = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onDocMouseDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("mousedown", onDocMouseDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [open]);

  return (
    <div className="fk-menu" ref={rootRef}>
      {trigger(open, () => setOpen((v) => !v))}
      {open ? (
        <div className={`fk-menu__popup fk-menu__popup--${align}`} role="menu">
          {items.map((item, i) => {
            if (item.type === "separator") {
              return <div key={i} className="fk-menu__separator" role="separator" />;
            }
            if (item.type === "label") {
              return (
                <div key={i} className="fk-menu__label">
                  {item.label}
                </div>
              );
            }
            return (
              <button
                key={i}
                type="button"
                role="menuitem"
                className={`fk-menu__item${item.danger ? " fk-menu__item--danger" : ""}`}
                disabled={item.disabled}
                onClick={() => {
                  setOpen(false);
                  item.onSelect();
                }}
              >
                {item.icon}
                {item.label}
                {item.hint ? <span className="fk-menu__item-hint">{item.hint}</span> : null}
              </button>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}

export default Menu;
